import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useInvoiceOrdersGridContext} from '../InvoiceOrdersGridContext';
import {formatFloatThousandsWithCommas} from "../../../../common/utils";
import styles from './StatsPanel.module.scss';

const StatsPanel = () => {
  const {totalAmount, totalCount} = useInvoiceOrdersGridContext();
  const editedTotalAmount = Boolean(totalAmount)
    ? formatFloatThousandsWithCommas(parseFloat(`${totalAmount}`).toFixed(2))
    : '0.00';

  return (
    <div className={styles.statsContainer}>
      <span className={styles.statsItem}>
        <FormattedMessage
          id={'invoiceOrders-stats-totalCount'}
          defaultMessage={'{count} invoices'}
          values={{count: totalCount}}
        />
      </span>
      <span className={styles.statsItem}>
        <FormattedMessage
          id={'invoiceOrders-stats-totalAmount'}
          defaultMessage={'{amount} ₪'}
          values={{amount: editedTotalAmount}}
        />
      </span>
    </div>
  );
};

export default StatsPanel;
